import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./frontend/navbar";
import DailyLog from "./frontend/dailylog";
import WeeklyReview from "./frontend/weeklyreview";
import MonthlyDashboard from "./frontend/monthlydashboard";
import QuarterlyReview from "./frontend/quarterlyreview";
import Dashboard from "./frontend/dashboard";
import AnalyticsDashboard from "./frontend/analyticsdashboard";
import Settings from "./frontend/settings";
import ProtectedRoute from "./frontend/protectedroute";
import HomeScreen from "./frontend/home";
import "./app.css";
//import SplashScreen from "./frontend/SplashScreen";
//<Route path="/splash" element={<SplashScreen />} />

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        
        <Route path="/" element={<HomeScreen />} />   {/* Always first screen */}
        <Route path="/daily" element={<ProtectedRoute><DailyLog /></ProtectedRoute>} />
        <Route path="/weekly" element={<ProtectedRoute><WeeklyReview /></ProtectedRoute>} />
        <Route path="/monthly" element={<ProtectedRoute><MonthlyDashboard /></ProtectedRoute>} />
        <Route path="/quarterly" element={<ProtectedRoute><QuarterlyReview /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><AnalyticsDashboard /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;